import { useState } from 'react';
import { Plus } from 'lucide-react';

export default function FaqAccordion({ items, dark = false, testid = 'faq-accordion' }) {
  const [openIndex, setOpenIndex] = useState(null);
  return (
    <div className={`divide-y rounded-2xl border ${dark ? 'divide-charcoal-line border-charcoal-line' : 'divide-hairline border-hairline bg-white'}`} data-testid={testid}>
      {items.map((item, i) => {
        const open = openIndex === i;
        return (
          <div key={i}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(open ? null : i)}
                aria-expanded={open}
                aria-controls={`faq-panel-${testid}-${i}`}
                id={`faq-trigger-${testid}-${i}`}
                data-testid={`faq-trigger-${i}`}
                className={`flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-heading text-base font-bold tracking-tight transition-colors sm:text-lg ${
                  dark ? 'text-offwhite hover:text-lime' : 'text-charcoal hover:text-charcoal/70'
                }`}
              >
                {item.q}
                <Plus
                  className={`h-5 w-5 shrink-0 transition-transform duration-300 ${open ? 'rotate-45' : ''} ${
                    dark ? 'text-lime' : 'text-charcoal'
                  }`}
                  aria-hidden="true"
                />
              </button>
            </h3>
            <div
              id={`faq-panel-${testid}-${i}`}
              role="region"
              aria-labelledby={`faq-trigger-${testid}-${i}`}
              className={`grid transition-[grid-template-rows] duration-300 ease-out ${open ? '[grid-template-rows:1fr]' : '[grid-template-rows:0fr]'}`}
            >
              <div className="overflow-hidden">
                <p className={`px-6 pb-6 text-sm leading-relaxed sm:text-base ${dark ? 'text-offwhite/70' : 'text-stonebrand'}`}>
                  {item.a}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
